// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-reporte-alineacion {
  width: 100%;
  height: 100%;
  position: relative;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cont-reporte-alineacion {
  width: 95%;
  height: 100%;
  position: relative;
  background-color: transparent;
  display: block;
  justify-content: center;
  align-items: center;
}

.cont-menu-alineacion {
  position: relative;
  display: flex;
  width: 100%;
  height: 24%;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgba(128, 128, 128, 0.37);
}

.cont-menu-disp {
  border-bottom: unset !important;
}

.cont-selectores {
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: 1px solid var(--border-table-color);
}

.cont-title-selectores {
  position: relative;
  display: flex;
  width: 100%;
  height: 15%;
  background-color: var(--third-color);
}

.cont-title-numeric-menu {
  position: relative;
  height: 100%;
  width: 10%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: aliceblue;

  font-weight: bold;
}

.cont-list-selectores {
  position: relative;
  height: 85%;
  width: 100%;
  display: block;
  justify-content: center;
  align-items: center;
  /* overflow-y: scroll;
  scrollbar-width: thin; */
}

.cont-title-options-menu {
  position: relative;
  height: 100%;
  width: 22%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: aliceblue;
}

.cont-periodos {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 35%;
  height: 100%;
  border-left: 1px solid rgba(128, 128, 128, 0.37);
  ;
}

.cont-periodo-manual {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40%;
  height: 100%;
}

.compact-periodo-manual {
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  width: 80%;
  height: 100%;
}

.cont-periodo-opciones {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 60%;
  height: 100%;
}

.cont-list-periodo {
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  width: 45%;
  height: 90%;
  /* overflow-y: scroll; */
  border: #50505081 1px solid;
  border-radius: 5px;
  scrollbar-width: thin;
}

.row-option-periodo {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 16.66%;
  color: #003757;
}

.row-option-periodo:hover {
  color: aliceblue;
  background-color: #6b6b6b9a !important;
  cursor: pointer;
}

.row-option-periodo:nth-child(odd) {
  background-color: #f8f9fa;
}

.row-option-periodo:nth-child(even) {
  background-color: #eeeeee;
}

.compact-menu-alineacion {
  position: relative;
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;

}

.cont-graf-alineacion {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50%;
  /* left: 4%; */
}

.cont-add-graf {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5%;
  height: 10%;
  top: 0%;
  left: 0;
}

.cont-download-graf {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100% !important;
  height: 100% !important;
  top: unset !important;
  left: unset !important;
  z-index: 1;
}

.img-field-download-graf {
  position: relative;
  height: 80% !important;
}

.img-field-download-graf:hover {
  height: 85% !important;
  cursor: pointer;
  transform: scale(1.1)
}

.cont-expand-graf {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100% !important;
  height: 100% !important;
  top: unset !important;
  left: unset !important;
  z-index: 1;
}

.img-field-expand-graf {
  position: relative;
  height: 80% !important;
}

.img-field-expand-graf:hover {
  height: 85% !important;
  cursor: pointer;
  transform: scale(1.1)
}

.cont-print-graf {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 5%;
  height: 10%;
  top: 10%;
  left: 0;
}

.cont-list-graf {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 15%;
  height: 50%;
  top: 25%;
  left: 0;
}

.compact-list-graf {
  display: block;
  position: relative;
  width: 90%;
  height: 95%;
}

.cont-row-graf {
  position: relative;
  width: 100%;
  height: 15%;
  display: flex;

}

.separate-rof-graf {
  width: 80%;
  height: 15;
  border-color: #9494943f;
}

.cont-color-graf {
  position: relative;
  width: 10%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.square-color-graf {
  position: relative;
  width: 60%;
  height: 30%;

  border-radius: 30%;
}

.cont-name-graf {
  position: relative;
  width: 80%;
  height: 100%;
  display: flex;
  justify-content: left;
  align-items: center;
  text-align: left;
  color: #505050;
  font-size: 10px;
}

.cont-table-alineacion {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 25%;
}

.compact-option-date {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 50%;
  padding: 10px 10px 0px 0px;
}

.lbl-option-date {
  font-size: medium !important;
  color: #003757;
  position: absolute;
}

.compact-option {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 16%;
  height: 100%;
  padding: 10px;
}

.compact-option-large {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 65%;
  height: 100%;
  padding: 10px;
}

.user-box-alineacion {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.user-box-alineacion .label-alineacion {
  position: absolute;
  top: 0px !important;
  left: 0;
  padding: 10px 0;
  /* font-size: 10px !important; */
  /* font-weight: bolder; */
  color: #003757;
  pointer-events: none;
  transition: .5s;
}

.user-box-alineacion input:focus~.label-alineacion,
.user-box-alineacion input:valid~.label-alineacion {
  top: -25px !important;
  left: 0px;
  color: #003757;
  font-size: 12px;
}

.user-box-alineacion input:focus~.label-alineacion,
.user-box-alineacion input:valid~.label-alineacion,
.user-box-alineacion .active {
  top: -10px !important;
  left: 0px;
  /* font-size: 12px; */
}


.user-box-alineacion input {
  width: 100%;
  padding: 10px 0;
  font-size: 12px;
  color: #003757;
  margin-bottom: 30px;
  border: none;
  border-bottom: 2px solid #003757;
  border-right: 2px solid #003757;
  outline: none;
  background: transparent;
  /* top: 30%; */
  position: relative;
}

.user-box-alineacion input:focus~.label-alineacion,
.user-box-alineacion input:valid~.label-alineacion {
  top: -10px;
  left: 0;
  color: #003757;
  font-size: 12px;
}

/********************************************/

/**********************************************/
.cont-info-graf {
  position: relative;
  display: block;
  width: 100%;
  height: 90%;
  top: 0% !important;
  left: 0% !important;
}

.cont-info-graf-modal {
  position: relative;
  display: block;
  width: 90%;
  height: 95%;
  top: 5%;
  left: 1%;

}

.cont-info-top {
  position: relative;
  display: flex;
  width: 100%;
  height: 10%;
}

.cont-info-center {
  position: relative;
  display: flex;
  width: 100%;
  height: 90%;
}

.cont-info-bottom {
  position: relative;
  justify-content: center;
  display: flex;
  height: 5%;
  width: 100%;
  position: absolute !important;
  width: 100% !important;
  top: -5% !important;
  height: 9% !important;
  border-radius: var(--border-radios-small) var(--border-radios-small) 0px 0px;
  box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), ;
  border: 1px solid var(--border-table-color);
  position: relative;
  display: flex;
  width: 100%;
  height: 10%;
}

.cont-info-bottom-modal {
  position: relative;
  display: flex;
  width: 100%;
  height: 10%;

}

.cont-text-info {
  position: relative;
  display: flex;
  width: 33.33%;
  height: 100%;
  justify-content: center;
  align-items: center;
  color: var(--txt-color);
  font-size: var(--font-size-small);
}


/*********************************************************/
.headtableReporte {}

.bodyInfoTable {
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;

}

.contTableDisp {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.contCheckDisp {
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  width: 5%;
  height: 70%;
}

.contInfoDisp {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 90%;
  border: 2px solid var(--border-table-color) !important;
}

.infoDisp {
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  border: #ffffff33 1px solid;
  border-radius: 10px;
}

.rowInfoDisp {
  justify-content: center;
  position: relative;
  display: flex;
  overflow: hidden;
  height: 26.666%;
  /* background: #5d5c69; */
  background-color: #43434d79;
  background-size: 400%;
  color: #003757;
  font-size: medium !important;
  /* border-radius: 0px 0px 10px 10px; */
  width: 100%;
}

.rowInfoDisp:nth-child(odd) {
  background-color: #f8f9fa;
}

.rowInfoDisp:nth-child(even) {
  background-color: #eeeeee;
}

.titlesInfoDisp {
  height: 15%;
  position: relative;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  background-color: var(--third-color) !important;
  /* max-height: 25px; */
}

.DispInfoCell {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.txtDispInfoCell {
  text-align: center;
  position: relative;
  width: 100%;
  height: auto;
  word-break: break-all;
  margin: 0 0 1em 1em;
  display: flex;
  font-size: var(--font-size-small);
  letter-spacing: 0.5px;
  justify-content: center;
  margin: 2%;
}

.lblInfoDisp {
  position: absolute;
  z-index: 2;
  left: 0;
  top: 0;
  color: aliceblue;
  margin-left: 1%;
}

.headerCellDisp {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 15%;
  border-left: 1px solid var(--white-color);
  color: var(--white-color);
  font-weight: unset !important;
  font-size: var(--font-size-small) !important;
}

.txtHeaderCellDisp {
  font-weight: unset !important;
  font-size: var(--font-size-small) !important;
  letter-spacing: 1px;
}

/******************************estilos de radiocheck************************************/
.checkTableDisp {
  -webkit-appearance: none;
  /* remove default */
  display: block;
  margin: 10px;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  cursor: pointer;
  vertical-align: middle;
  box-shadow: hsla(0, 0%, 100%, .15) 0 1px 1px, inset hsla(0, 0%, 0%, .5) 0 0 0 1px;
  background-color: #003757;
  /* border-color: ; */
  background-image: -webkit-radial-gradient(hsla(200, 100%, 90%, 1) 0%, hsla(200, 100%, 70%, 1) 15%, hsla(200, 100%, 60%, .3) 28%, hsla(200, 100%, 30%, 0) 70%);
  background-repeat: no-repeat;
  -webkit-transition: background-position .15s cubic-bezier(.8, 0, 1, 1),
    -webkit-transform .25s cubic-bezier(.8, 0, 1, 1);
  outline: none;
}

.checkTableDisp:checked {
  -webkit-transition: background-position .2s .15s cubic-bezier(0, 0, .2, 1),
    -webkit-transform .25s cubic-bezier(0, 0, .2, 1);
}

.checkTableDisp:active {
  -webkit-transform: scale(1.5);
  -webkit-transition: -webkit-transform .1s cubic-bezier(0, 0, .2, 1);
}



/* The up/down direction logic */

.checkTableDisp,
.checkTableDisp:active {
  background-position: 0 24px;
}

.checkTableDisp:checked {
  background-position: 0 0;
}

.checkTableDisp:checked~.checkTableDisp,
.checkTableDisp:checked~.checkTableDisp:active {
  background-position: 0 -24px;
}


.cont-option-todos {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: var(--main-color);
  font-size: var(--font-size-small);
  top: 30%;
  height: 10%;
  position: absolute;

}

.cont-option-todos input:hover {
  cursor: pointer;
}


/************* tooltip ****************/
.recharts-responsive-container {
  z-index: 3 !important;
  /* background-color: var(--); */
  border: 1px solid var(--border-table-color);
  border-radius: 0px 0px var(--border-radios-small) var(--border-radios-small);
}

.recharts-legend-item {
  font-size: var(--font-size-xSmall);
  /* font-weight: bold; */
  color: var(--txt-color);
}

.custom-tooltip-disponibilidad {
  background-color: white;
  border-radius: 5px;
  border: 2px solid var(--border-table-color);
  padding: 5%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  /* height: 200px; */
  z-index: 3;
  overflow: auto;
  max-height: 100%;
}

.cont-tooltip-disponibilidad {
  position: relative;
  display: block;
  width: 95%;
  height: 95%;
  /* max-height: 400px; */
  overflow: auto;
  /* border-color: 1px solid #003757;
background-color: red;
border: 1px; */
}

.row-tooltip {
  display: flex;
  align-items: center;
  justify-content: left;
  width: 200px;
  height: 20px;

}

.title-tooltip {
  color: #505050;
  display: flex;
}

/* *********************************************************** */
.contSearchHostReporte {
  position: relative;
  height: 100%;
  width: 30%;
  z-index: 2;
  display: block;
  padding-left: 3%;
}

.mainbox-searchHostReporte {
  box-sizing: border-box;
  position: relative;
  width: 230px;
  top: 10%;
  height: 80%;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  background-color: var(--white-color);
  transition: all 0.3s ease;
  box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);
  border: 1px solid #f0f8ff3d;
}

.row-searchHost-listReporte {
  background-color: #0e182dcc;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 30px;
  color: #088eee;
}

.row-searchHost-listReporte:hover {
  background-color: aliceblue;
  cursor: pointer;
}

.cont-list-selectoresHost {
  position: relative;
  height: 85%;
  width: 100%;
  display: block;
  justify-content: center;
  align-items: center;
  overflow-y: scroll;
  scrollbar-width: thin;
}

/*******************************************/
.cont-option-reporte-gs .compactSelectorAdminGS {
  top: -10% !important;
}

.object-add-serie {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 10%;
  height: 33.33%;
  top: 0%;
  left: -8%;
}

.cont-controls {
  position: relative;
  display: block;
  justify-content: center;
  align-items: center;
  width: 10%;
  height: 100%;
  border: unset !important;

}

.row-controls {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 33.33%;
}

/***************************************************************/
.contSearchBtnrange {
  position: absolute;
  width: 10%;
  height: 100%;
  left: 65%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.compactSearchBtnrange {
  position: relative;
  width: 85%;
  /* height: 40%; */
}

.compactSearchBtnrange .actAzul {
  height: 3vh
}

.contSelectRangeDate {
  position: absolute;
  width: 20%;
  height: 100%;
  left: 75%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* Cambiar el color de fondo del calendario */
.rs-picker-daterange-panel {
  background-color: var(--white-color);
  /* min-width: unset !important;
width: 300px !important;
height: 200px !important; */
}

/* Cambiar el estilo de los días seleccionados */
.rs-calendar-table-cell-selected {

  color: white;
}



/* Personalizar el input */
.rs-picker-toggle {
  border: 2px solid #007bff;
  padding: 10px;
  font-size: 16px;
}

.reporte-gs-datepicker .rs-input {
  background-color: var(--third-color) !important;
  color: var(--white-color) !important;
  font-size: var(--font-size-small);
  border-radius: var(--border-radios-small) 0px 0px var(--border-radios-small) !important;
}

.reporte-gs-datepicker .rs-input::placeholder {
  color: var(--white-color) !important;
}

.reporte-gs-datepicker .rs-input:hover {
  cursor: pointer;
}

.reporte-gs-datepicker .rs-input-group-addon {
  background-color: var(--third-color) !important;
  color: var(--white-color) !important;
  font-size: var(--font-size-small);
  border-radius: 0px var(--border-radios-small) var(--border-radios-small) 0px !important;
}

.rs-picker-popup {
  /* width: 500px !important; */
  /* left: 63% !important; */
  height: 340px !important;
  /* bottom: 0% !important; */
}

.rs-calendar-time-dropdown {
  color: var(--txt-color) !important;
  font-size: var(--font-size-xSmall) !important;
}

.rs-calendar-btn-close {
  background-color: var(--border-table-color) !important;
}

.rs-picker-daterange-panel {
  min-width: unset !important;
  width: 100% !important;
  height: 100% !important;
}

.rs-picker-daterange-calendar-group {
  min-width: unset !important;
  width: 100% !important;
  min-width: unset !important;
  min-height: unset !important;
  width: 400px !important;
  height: 250px !important;
}

.rs-calendar {
  min-width: unset !important;

}

.rs-picker-error>.rs-picker-input-group,
.rs-picker-error>.rs-picker-input-group:hover {
  border-color: unset !important;
}

.rs-picker-daterange-header {
  color: var(--txt-color) !important;
  font-size: var(--font-size-small) !important;
}

.rs-btn-link {
  color: var(--second-color) !important;
  font-size: var(--font-size-small) !important;
}

.rs-picker-toolbar-ranges {
  display: none !important;
}

.rs-calendar-table-cell-content {
  height: 20px !important;
  width: 25px !important;
}

.rs-calendar-table-cell,
.rs-calendar-table-header-cell {
  width: unset !important;
}

.rs-calendar-table-cell-content {
  font-size: var(--font-size-xSmall) !important;
}

.rs-btn-sm {
  line-height: 15px !important;
}

.rs-calendar-header {
  font-size: var(--font-size-xSmall) !important;
}

.rs-picker-daterange-calendar-group .rs-picker-popup .rs-calendar {
  min-width: unset !important;
  min-height: unset !important;
  width: 280px !important;
  height: 200px !important;
}

.rs-picker-daterange-content {
  width: 90% !important;
}

.rs-calendar-header-time-toolbar {
  display: flex !important;
}

.rs-calendar-header-month-toolbar {
  display: flex !important;
}

/* .rs-picker-daterange-calendar-group .rs-calendar{
  width: 230px !important;
} */
/* .rs-stack-item{
  width: 100% !important;
height: 100% !important;
}
.rs-picker-daterange-predefined{
  width: 20% !important;
}

.rs-calendar .rs-calendar-body{
  width: 100% !important;
}
.rs-calendar .rs-calendar-body .rs-calendar-table{
  width: 100% !important;
}  */
/**********************************************************************************/
.cont-report-gs {
  width: 100%;
  height: 100%;
  display: flex;

}

.cont-left-report-gs {
  width: 10%;
  height: 100%;
  display: flex;
}

.cont-table-metricas {
  position: absolute;
  width: 10%;
  display: flex;
  justify-content: center;
  height: 30%;
  left: 1%;
  top: 30%;

}

.cont-rows-table-metricas {
  width: 100%;
  height: 90%;
  display: block;
  overflow: auto;

}

.cont-rigth-report-gs {
  width: 90%;
  height: 100%;
  display: flex;
}

.recharts-layer {
  font-size: var(--font-size-xSmall);
  color: var(--txt-color) !important;
}

.rs-btn-primary {
  right: 100% !important;
}


/* **************************** horizontal Movil****************************** */
@media (min-width: 500px) and(max-width: 900px) {}

/* ****************************Movil****************************** */
@media (max-width: 500px) {
  .contGrafKapi {
    width: 300% !important;
    /* height: 200 !important; */
  }
}`, "",{"version":3,"sources":["webpack://./src/components/reportes-components/styles/alineacion.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kDAAkD;AACpD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;;EAEhB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB;0BACwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,gDAAgD;;AAElD;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,wBAAwB;EACxB,2BAA2B;EAC3B,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;;AAErB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,OAAO;EACP,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,QAAQ;EACR,OAAO;AACT;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;;AAEf;;AAEA;EACE,UAAU;EACV,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;;EAEX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,OAAO;EACP,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;;;EAGE,qBAAqB;EACrB,SAAS;EACT,qBAAqB;AACvB;;;AAGA;EACE,WAAW;EACX,eAAe;EACf,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,gCAAgC;EAChC,+BAA+B;EAC/B,aAAa;EACb,uBAAuB;EACvB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,UAAU;EACV,OAAO;EACP,cAAc;EACd,eAAe;AACjB;;AAEA,6CAA6C;;AAE7C,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,WAAW;EACX,OAAO;EACP,QAAQ;;AAEV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,aAAa;EACb,UAAU;EACV,WAAW;EACX,6BAA6B;EAC7B,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,4EAA4E;EAC5E,iDAAiD;EACjD,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;;AAEb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;;AAGA,0DAA0D;AAC1D,mBAAmB;;AAEnB;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;;AAEd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,sDAAsD;AACxD;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,4BAA4B;EAC5B,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,qBAAqB;EACrB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,OAAO;EACP,MAAM;EACN,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,yCAAyC;EACzC,yBAAyB;EACzB,6BAA6B;EAC7B,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;EAC7B,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,wFAAwF;AACxF;EACE,wBAAwB;EACxB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,iFAAiF;EACjF,yBAAyB;EACzB,oBAAoB;EACpB,6JAA6J;EAC7J,4BAA4B;EAC5B;oDACkD;EAClD,aAAa;AACf;;AAEA;EACE;oDACkD;AACpD;;AAEA;EACE,6BAA6B;EAC7B,mEAAmE;AACrE;;;;AAIA,gCAAgC;;AAEhC;;EAEE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;;AAGA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,iCAAiC;EACjC,QAAQ;EACR,WAAW;EACX,kBAAkB;;AAEpB;;AAEA;EACE,eAAe;AACjB;;;AAGA,uCAAuC;AACvC;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,2CAA2C;EAC3C,4EAA4E;AAC9E;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,2CAA2C;EAC3C,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,WAAW;EACX,uBAAuB;EACvB,cAAc;EACd;;cAEY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,YAAY;;AAEd;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,4CAA4C;AAC5C;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,OAAO;EACP,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,UAAU;EACV,YAAY;EACZ,wBAAwB;;AAE1B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,oCAAoC;EACpC;;2BAEyB;AAC3B;;AAEA,gDAAgD;AAChD;;EAEE,YAAY;AACd;;;;AAIA,0BAA0B;AAC1B;EACE,yBAAyB;EACzB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,iCAAiC;EACjC,uFAAuF;AACzF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+CAA+C;EAC/C,oCAAoC;EACpC,iCAAiC;EACjC,uFAAuF;AACzF;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;EAC1B,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,6CAA6C;AAC/C;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;;AAE7B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;GAEG;AACH;;;;;;;;;;;;;IAaI;AACJ,mFAAmF;AACnF;EACE,WAAW;EACX,YAAY;EACZ,aAAa;;AAEf;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,QAAQ;EACR,QAAQ;;AAEV;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;EACd,cAAc;;AAEhB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kCAAkC;EAClC,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;;AAGA,gFAAgF;AAChF,iDAAiD;;AAEjD,oEAAoE;AACpE;EACE;IACE,sBAAsB;IACtB,4BAA4B;EAC9B;AACF","sourcesContent":[".main-reporte-alineacion {\r\n  width: 100%;\r\n  height: 100%;\r\n  position: relative;\r\n  background-color: transparent;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.cont-reporte-alineacion {\r\n  width: 95%;\r\n  height: 100%;\r\n  position: relative;\r\n  background-color: transparent;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.cont-menu-alineacion {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 24%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  border-bottom: 1px solid rgba(128, 128, 128, 0.37);\r\n}\r\n\r\n.cont-menu-disp {\r\n  border-bottom: unset !important;\r\n}\r\n\r\n.cont-selectores {\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 1px solid var(--border-table-color);\r\n}\r\n\r\n.cont-title-selectores {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 15%;\r\n  background-color: var(--third-color);\r\n}\r\n\r\n.cont-title-numeric-menu {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 10%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: aliceblue;\r\n\r\n  font-weight: bold;\r\n}\r\n\r\n.cont-list-selectores {\r\n  position: relative;\r\n  height: 85%;\r\n  width: 100%;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  /* overflow-y: scroll;\r\n  scrollbar-width: thin; */\r\n}\r\n\r\n.cont-title-options-menu {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 22%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: aliceblue;\r\n}\r\n\r\n.cont-periodos {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 35%;\r\n  height: 100%;\r\n  border-left: 1px solid rgba(128, 128, 128, 0.37);\r\n  ;\r\n}\r\n\r\n.cont-periodo-manual {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 40%;\r\n  height: 100%;\r\n}\r\n\r\n.compact-periodo-manual {\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 80%;\r\n  height: 100%;\r\n}\r\n\r\n.cont-periodo-opciones {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  width: 60%;\r\n  height: 100%;\r\n}\r\n\r\n.cont-list-periodo {\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 45%;\r\n  height: 90%;\r\n  /* overflow-y: scroll; */\r\n  border: #50505081 1px solid;\r\n  border-radius: 5px;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.row-option-periodo {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 16.66%;\r\n  color: #003757;\r\n}\r\n\r\n.row-option-periodo:hover {\r\n  color: aliceblue;\r\n  background-color: #6b6b6b9a !important;\r\n  cursor: pointer;\r\n}\r\n\r\n.row-option-periodo:nth-child(odd) {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.row-option-periodo:nth-child(even) {\r\n  background-color: #eeeeee;\r\n}\r\n\r\n.compact-menu-alineacion {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n\r\n}\r\n\r\n.cont-graf-alineacion {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 50%;\r\n  /* left: 4%; */\r\n}\r\n\r\n.cont-add-graf {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 5%;\r\n  height: 10%;\r\n  top: 0%;\r\n  left: 0;\r\n}\r\n\r\n.cont-download-graf {\r\n  position: absolute;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  top: unset !important;\r\n  left: unset !important;\r\n  z-index: 1;\r\n}\r\n\r\n.img-field-download-graf {\r\n  position: relative;\r\n  height: 80% !important;\r\n}\r\n\r\n.img-field-download-graf:hover {\r\n  height: 85% !important;\r\n  cursor: pointer;\r\n  transform: scale(1.1)\r\n}\r\n\r\n.cont-expand-graf {\r\n  position: absolute;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n  top: unset !important;\r\n  left: unset !important;\r\n  z-index: 1;\r\n}\r\n\r\n.img-field-expand-graf {\r\n  position: relative;\r\n  height: 80% !important;\r\n}\r\n\r\n.img-field-expand-graf:hover {\r\n  height: 85% !important;\r\n  cursor: pointer;\r\n  transform: scale(1.1)\r\n}\r\n\r\n.cont-print-graf {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 5%;\r\n  height: 10%;\r\n  top: 10%;\r\n  left: 0;\r\n}\r\n\r\n.cont-list-graf {\r\n  position: absolute;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 15%;\r\n  height: 50%;\r\n  top: 25%;\r\n  left: 0;\r\n}\r\n\r\n.compact-list-graf {\r\n  display: block;\r\n  position: relative;\r\n  width: 90%;\r\n  height: 95%;\r\n}\r\n\r\n.cont-row-graf {\r\n  position: relative;\r\n  width: 100%;\r\n  height: 15%;\r\n  display: flex;\r\n\r\n}\r\n\r\n.separate-rof-graf {\r\n  width: 80%;\r\n  height: 15;\r\n  border-color: #9494943f;\r\n}\r\n\r\n.cont-color-graf {\r\n  position: relative;\r\n  width: 10%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.square-color-graf {\r\n  position: relative;\r\n  width: 60%;\r\n  height: 30%;\r\n\r\n  border-radius: 30%;\r\n}\r\n\r\n.cont-name-graf {\r\n  position: relative;\r\n  width: 80%;\r\n  height: 100%;\r\n  display: flex;\r\n  justify-content: left;\r\n  align-items: center;\r\n  text-align: left;\r\n  color: #505050;\r\n  font-size: 10px;\r\n}\r\n\r\n.cont-table-alineacion {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 25%;\r\n}\r\n\r\n.compact-option-date {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 50%;\r\n  padding: 10px 10px 0px 0px;\r\n}\r\n\r\n.lbl-option-date {\r\n  font-size: medium !important;\r\n  color: #003757;\r\n  position: absolute;\r\n}\r\n\r\n.compact-option {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 16%;\r\n  height: 100%;\r\n  padding: 10px;\r\n}\r\n\r\n.compact-option-large {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 65%;\r\n  height: 100%;\r\n  padding: 10px;\r\n}\r\n\r\n.user-box-alineacion {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.user-box-alineacion .label-alineacion {\r\n  position: absolute;\r\n  top: 0px !important;\r\n  left: 0;\r\n  padding: 10px 0;\r\n  /* font-size: 10px !important; */\r\n  /* font-weight: bolder; */\r\n  color: #003757;\r\n  pointer-events: none;\r\n  transition: .5s;\r\n}\r\n\r\n.user-box-alineacion input:focus~.label-alineacion,\r\n.user-box-alineacion input:valid~.label-alineacion {\r\n  top: -25px !important;\r\n  left: 0px;\r\n  color: #003757;\r\n  font-size: 12px;\r\n}\r\n\r\n.user-box-alineacion input:focus~.label-alineacion,\r\n.user-box-alineacion input:valid~.label-alineacion,\r\n.user-box-alineacion .active {\r\n  top: -10px !important;\r\n  left: 0px;\r\n  /* font-size: 12px; */\r\n}\r\n\r\n\r\n.user-box-alineacion input {\r\n  width: 100%;\r\n  padding: 10px 0;\r\n  font-size: 12px;\r\n  color: #003757;\r\n  margin-bottom: 30px;\r\n  border: none;\r\n  border-bottom: 2px solid #003757;\r\n  border-right: 2px solid #003757;\r\n  outline: none;\r\n  background: transparent;\r\n  /* top: 30%; */\r\n  position: relative;\r\n}\r\n\r\n.user-box-alineacion input:focus~.label-alineacion,\r\n.user-box-alineacion input:valid~.label-alineacion {\r\n  top: -10px;\r\n  left: 0;\r\n  color: #003757;\r\n  font-size: 12px;\r\n}\r\n\r\n/********************************************/\r\n\r\n/**********************************************/\r\n.cont-info-graf {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  height: 90%;\r\n  top: 0% !important;\r\n  left: 0% !important;\r\n}\r\n\r\n.cont-info-graf-modal {\r\n  position: relative;\r\n  display: block;\r\n  width: 90%;\r\n  height: 95%;\r\n  top: 5%;\r\n  left: 1%;\r\n\r\n}\r\n\r\n.cont-info-top {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 10%;\r\n}\r\n\r\n.cont-info-center {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 90%;\r\n}\r\n\r\n.cont-info-bottom {\r\n  position: relative;\r\n  justify-content: center;\r\n  display: flex;\r\n  height: 5%;\r\n  width: 100%;\r\n  position: absolute !important;\r\n  width: 100% !important;\r\n  top: -5% !important;\r\n  height: 9% !important;\r\n  border-radius: var(--border-radios-small) var(--border-radios-small) 0px 0px;\r\n  box-shadow: 0 0 5px 5px rgba(24, 94, 224, 0.15), ;\r\n  border: 1px solid var(--border-table-color);\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 10%;\r\n}\r\n\r\n.cont-info-bottom-modal {\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  height: 10%;\r\n\r\n}\r\n\r\n.cont-text-info {\r\n  position: relative;\r\n  display: flex;\r\n  width: 33.33%;\r\n  height: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: var(--txt-color);\r\n  font-size: var(--font-size-small);\r\n}\r\n\r\n\r\n/*********************************************************/\r\n.headtableReporte {}\r\n\r\n.bodyInfoTable {\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n\r\n}\r\n\r\n.contTableDisp {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.contCheckDisp {\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 5%;\r\n  height: 70%;\r\n}\r\n\r\n.contInfoDisp {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 90%;\r\n  border: 2px solid var(--border-table-color) !important;\r\n}\r\n\r\n.infoDisp {\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 100%;\r\n  border: #ffffff33 1px solid;\r\n  border-radius: 10px;\r\n}\r\n\r\n.rowInfoDisp {\r\n  justify-content: center;\r\n  position: relative;\r\n  display: flex;\r\n  overflow: hidden;\r\n  height: 26.666%;\r\n  /* background: #5d5c69; */\r\n  background-color: #43434d79;\r\n  background-size: 400%;\r\n  color: #003757;\r\n  font-size: medium !important;\r\n  /* border-radius: 0px 0px 10px 10px; */\r\n  width: 100%;\r\n}\r\n\r\n.rowInfoDisp:nth-child(odd) {\r\n  background-color: #f8f9fa;\r\n}\r\n\r\n.rowInfoDisp:nth-child(even) {\r\n  background-color: #eeeeee;\r\n}\r\n\r\n.titlesInfoDisp {\r\n  height: 15%;\r\n  position: relative;\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: center;\r\n  align-items: center;\r\n  background-color: var(--third-color) !important;\r\n  /* max-height: 25px; */\r\n}\r\n\r\n.DispInfoCell {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n}\r\n\r\n.txtDispInfoCell {\r\n  text-align: center;\r\n  position: relative;\r\n  width: 100%;\r\n  height: auto;\r\n  word-break: break-all;\r\n  margin: 0 0 1em 1em;\r\n  display: flex;\r\n  font-size: var(--font-size-small);\r\n  letter-spacing: 0.5px;\r\n  justify-content: center;\r\n  margin: 2%;\r\n}\r\n\r\n.lblInfoDisp {\r\n  position: absolute;\r\n  z-index: 2;\r\n  left: 0;\r\n  top: 0;\r\n  color: aliceblue;\r\n  margin-left: 1%;\r\n}\r\n\r\n.headerCellDisp {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  width: 15%;\r\n  border-left: 1px solid var(--white-color);\r\n  color: var(--white-color);\r\n  font-weight: unset !important;\r\n  font-size: var(--font-size-small) !important;\r\n}\r\n\r\n.txtHeaderCellDisp {\r\n  font-weight: unset !important;\r\n  font-size: var(--font-size-small) !important;\r\n  letter-spacing: 1px;\r\n}\r\n\r\n/******************************estilos de radiocheck************************************/\r\n.checkTableDisp {\r\n  -webkit-appearance: none;\r\n  /* remove default */\r\n  display: block;\r\n  margin: 10px;\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 12px;\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n  box-shadow: hsla(0, 0%, 100%, .15) 0 1px 1px, inset hsla(0, 0%, 0%, .5) 0 0 0 1px;\r\n  background-color: #003757;\r\n  /* border-color: ; */\r\n  background-image: -webkit-radial-gradient(hsla(200, 100%, 90%, 1) 0%, hsla(200, 100%, 70%, 1) 15%, hsla(200, 100%, 60%, .3) 28%, hsla(200, 100%, 30%, 0) 70%);\r\n  background-repeat: no-repeat;\r\n  -webkit-transition: background-position .15s cubic-bezier(.8, 0, 1, 1),\r\n    -webkit-transform .25s cubic-bezier(.8, 0, 1, 1);\r\n  outline: none;\r\n}\r\n\r\n.checkTableDisp:checked {\r\n  -webkit-transition: background-position .2s .15s cubic-bezier(0, 0, .2, 1),\r\n    -webkit-transform .25s cubic-bezier(0, 0, .2, 1);\r\n}\r\n\r\n.checkTableDisp:active {\r\n  -webkit-transform: scale(1.5);\r\n  -webkit-transition: -webkit-transform .1s cubic-bezier(0, 0, .2, 1);\r\n}\r\n\r\n\r\n\r\n/* The up/down direction logic */\r\n\r\n.checkTableDisp,\r\n.checkTableDisp:active {\r\n  background-position: 0 24px;\r\n}\r\n\r\n.checkTableDisp:checked {\r\n  background-position: 0 0;\r\n}\r\n\r\n.checkTableDisp:checked~.checkTableDisp,\r\n.checkTableDisp:checked~.checkTableDisp:active {\r\n  background-position: 0 -24px;\r\n}\r\n\r\n\r\n.cont-option-todos {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  color: var(--main-color);\r\n  font-size: var(--font-size-small);\r\n  top: 30%;\r\n  height: 10%;\r\n  position: absolute;\r\n\r\n}\r\n\r\n.cont-option-todos input:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n\r\n/************* tooltip ****************/\r\n.recharts-responsive-container {\r\n  z-index: 3 !important;\r\n  /* background-color: var(--); */\r\n  border: 1px solid var(--border-table-color);\r\n  border-radius: 0px 0px var(--border-radios-small) var(--border-radios-small);\r\n}\r\n\r\n.recharts-legend-item {\r\n  font-size: var(--font-size-xSmall);\r\n  /* font-weight: bold; */\r\n  color: var(--txt-color);\r\n}\r\n\r\n.custom-tooltip-disponibilidad {\r\n  background-color: white;\r\n  border-radius: 5px;\r\n  border: 2px solid var(--border-table-color);\r\n  padding: 5%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: auto;\r\n  /* height: 200px; */\r\n  z-index: 3;\r\n  overflow: auto;\r\n  max-height: 100%;\r\n}\r\n\r\n.cont-tooltip-disponibilidad {\r\n  position: relative;\r\n  display: block;\r\n  width: 95%;\r\n  height: 95%;\r\n  /* max-height: 400px; */\r\n  overflow: auto;\r\n  /* border-color: 1px solid #003757;\r\nbackground-color: red;\r\nborder: 1px; */\r\n}\r\n\r\n.row-tooltip {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: left;\r\n  width: 200px;\r\n  height: 20px;\r\n\r\n}\r\n\r\n.title-tooltip {\r\n  color: #505050;\r\n  display: flex;\r\n}\r\n\r\n/* *********************************************************** */\r\n.contSearchHostReporte {\r\n  position: relative;\r\n  height: 100%;\r\n  width: 30%;\r\n  z-index: 2;\r\n  display: block;\r\n  padding-left: 3%;\r\n}\r\n\r\n.mainbox-searchHostReporte {\r\n  box-sizing: border-box;\r\n  position: relative;\r\n  width: 230px;\r\n  top: 10%;\r\n  height: 80%;\r\n  display: flex;\r\n  flex-direction: row-reverse;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 5px;\r\n  background-color: var(--white-color);\r\n  transition: all 0.3s ease;\r\n  box-shadow: 3px 3px 10px rgba(67, 67, 67, 0.4);\r\n  border: 1px solid #f0f8ff3d;\r\n}\r\n\r\n.row-searchHost-listReporte {\r\n  background-color: #0e182dcc;\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 30px;\r\n  color: #088eee;\r\n}\r\n\r\n.row-searchHost-listReporte:hover {\r\n  background-color: aliceblue;\r\n  cursor: pointer;\r\n}\r\n\r\n.cont-list-selectoresHost {\r\n  position: relative;\r\n  height: 85%;\r\n  width: 100%;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  overflow-y: scroll;\r\n  scrollbar-width: thin;\r\n}\r\n\r\n/*******************************************/\r\n.cont-option-reporte-gs .compactSelectorAdminGS {\r\n  top: -10% !important;\r\n}\r\n\r\n.object-add-serie {\r\n  position: absolute;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 10%;\r\n  height: 33.33%;\r\n  top: 0%;\r\n  left: -8%;\r\n}\r\n\r\n.cont-controls {\r\n  position: relative;\r\n  display: block;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 10%;\r\n  height: 100%;\r\n  border: unset !important;\r\n\r\n}\r\n\r\n.row-controls {\r\n  position: relative;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 100%;\r\n  height: 33.33%;\r\n}\r\n\r\n/***************************************************************/\r\n.contSearchBtnrange {\r\n  position: absolute;\r\n  width: 10%;\r\n  height: 100%;\r\n  left: 65%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.compactSearchBtnrange {\r\n  position: relative;\r\n  width: 85%;\r\n  /* height: 40%; */\r\n}\r\n\r\n.compactSearchBtnrange .actAzul {\r\n  height: 3vh\r\n}\r\n\r\n.contSelectRangeDate {\r\n  position: absolute;\r\n  width: 20%;\r\n  height: 100%;\r\n  left: 75%;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n/* Cambiar el color de fondo del calendario */\r\n.rs-picker-daterange-panel {\r\n  background-color: var(--white-color);\r\n  /* min-width: unset !important;\r\nwidth: 300px !important;\r\nheight: 200px !important; */\r\n}\r\n\r\n/* Cambiar el estilo de los días seleccionados */\r\n.rs-calendar-table-cell-selected {\r\n\r\n  color: white;\r\n}\r\n\r\n\r\n\r\n/* Personalizar el input */\r\n.rs-picker-toggle {\r\n  border: 2px solid #007bff;\r\n  padding: 10px;\r\n  font-size: 16px;\r\n}\r\n\r\n.reporte-gs-datepicker .rs-input {\r\n  background-color: var(--third-color) !important;\r\n  color: var(--white-color) !important;\r\n  font-size: var(--font-size-small);\r\n  border-radius: var(--border-radios-small) 0px 0px var(--border-radios-small) !important;\r\n}\r\n\r\n.reporte-gs-datepicker .rs-input::placeholder {\r\n  color: var(--white-color) !important;\r\n}\r\n\r\n.reporte-gs-datepicker .rs-input:hover {\r\n  cursor: pointer;\r\n}\r\n\r\n.reporte-gs-datepicker .rs-input-group-addon {\r\n  background-color: var(--third-color) !important;\r\n  color: var(--white-color) !important;\r\n  font-size: var(--font-size-small);\r\n  border-radius: 0px var(--border-radios-small) var(--border-radios-small) 0px !important;\r\n}\r\n\r\n.rs-picker-popup {\r\n  /* width: 500px !important; */\r\n  /* left: 63% !important; */\r\n  height: 340px !important;\r\n  /* bottom: 0% !important; */\r\n}\r\n\r\n.rs-calendar-time-dropdown {\r\n  color: var(--txt-color) !important;\r\n  font-size: var(--font-size-xSmall) !important;\r\n}\r\n\r\n.rs-calendar-btn-close {\r\n  background-color: var(--border-table-color) !important;\r\n}\r\n\r\n.rs-picker-daterange-panel {\r\n  min-width: unset !important;\r\n  width: 100% !important;\r\n  height: 100% !important;\r\n}\r\n\r\n.rs-picker-daterange-calendar-group {\r\n  min-width: unset !important;\r\n  width: 100% !important;\r\n  min-width: unset !important;\r\n  min-height: unset !important;\r\n  width: 400px !important;\r\n  height: 250px !important;\r\n}\r\n\r\n.rs-calendar {\r\n  min-width: unset !important;\r\n\r\n}\r\n\r\n.rs-picker-error>.rs-picker-input-group,\r\n.rs-picker-error>.rs-picker-input-group:hover {\r\n  border-color: unset !important;\r\n}\r\n\r\n.rs-picker-daterange-header {\r\n  color: var(--txt-color) !important;\r\n  font-size: var(--font-size-small) !important;\r\n}\r\n\r\n.rs-btn-link {\r\n  color: var(--second-color) !important;\r\n  font-size: var(--font-size-small) !important;\r\n}\r\n\r\n.rs-picker-toolbar-ranges {\r\n  display: none !important;\r\n}\r\n\r\n.rs-calendar-table-cell-content {\r\n  height: 20px !important;\r\n  width: 25px !important;\r\n}\r\n\r\n.rs-calendar-table-cell,\r\n.rs-calendar-table-header-cell {\r\n  width: unset !important;\r\n}\r\n\r\n.rs-calendar-table-cell-content {\r\n  font-size: var(--font-size-xSmall) !important;\r\n}\r\n\r\n.rs-btn-sm {\r\n  line-height: 15px !important;\r\n}\r\n\r\n.rs-calendar-header {\r\n  font-size: var(--font-size-xSmall) !important;\r\n}\r\n\r\n.rs-picker-daterange-calendar-group .rs-picker-popup .rs-calendar {\r\n  min-width: unset !important;\r\n  min-height: unset !important;\r\n  width: 280px !important;\r\n  height: 200px !important;\r\n}\r\n\r\n.rs-picker-daterange-content {\r\n  width: 90% !important;\r\n}\r\n\r\n.rs-calendar-header-time-toolbar {\r\n  display: flex !important;\r\n}\r\n\r\n.rs-calendar-header-month-toolbar {\r\n  display: flex !important;\r\n}\r\n\r\n/* .rs-picker-daterange-calendar-group .rs-calendar{\r\n  width: 230px !important;\r\n} */\r\n/* .rs-stack-item{\r\n  width: 100% !important;\r\nheight: 100% !important;\r\n}\r\n.rs-picker-daterange-predefined{\r\n  width: 20% !important;\r\n}\r\n\r\n.rs-calendar .rs-calendar-body{\r\n  width: 100% !important;\r\n}\r\n.rs-calendar .rs-calendar-body .rs-calendar-table{\r\n  width: 100% !important;\r\n}  */\r\n/**********************************************************************************/\r\n.cont-report-gs {\r\n  width: 100%;\r\n  height: 100%;\r\n  display: flex;\r\n\r\n}\r\n\r\n.cont-left-report-gs {\r\n  width: 10%;\r\n  height: 100%;\r\n  display: flex;\r\n}\r\n\r\n.cont-table-metricas {\r\n  position: absolute;\r\n  width: 10%;\r\n  display: flex;\r\n  justify-content: center;\r\n  height: 30%;\r\n  left: 1%;\r\n  top: 30%;\r\n\r\n}\r\n\r\n.cont-rows-table-metricas {\r\n  width: 100%;\r\n  height: 90%;\r\n  display: block;\r\n  overflow: auto;\r\n\r\n}\r\n\r\n.cont-rigth-report-gs {\r\n  width: 90%;\r\n  height: 100%;\r\n  display: flex;\r\n}\r\n\r\n.recharts-layer {\r\n  font-size: var(--font-size-xSmall);\r\n  color: var(--txt-color) !important;\r\n}\r\n\r\n.rs-btn-primary {\r\n  right: 100% !important;\r\n}\r\n\r\n\r\n/* **************************** horizontal Movil****************************** */\r\n@media (min-width: 500px) and(max-width: 900px) {}\r\n\r\n/* ****************************Movil****************************** */\r\n@media (max-width: 500px) {\r\n  .contGrafKapi {\r\n    width: 300% !important;\r\n    /* height: 200 !important; */\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
